import { render, staticRenderFns } from "./serOrganList.vue?vue&type=template&id=7043675d&scoped=true&"
import script from "./serOrganList.vue?vue&type=script&lang=js&"
export * from "./serOrganList.vue?vue&type=script&lang=js&"
import style0 from "./serOrganList.vue?vue&type=style&index=0&id=7043675d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7043675d",
  null
  
)

export default component.exports